import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
function CreateWO(props) {
    const {appt_id} = useParams();
    const [WoData, setWoData] = useState([]);
    const [labdept, setlabDept] = useState([]);
    const [isAcceptDisabled, setIsAcceptDisabled] = useState(false);
    const [orderResponse, setOrderResponse] = useState(null);
    useEffect(() => {
        const fetchLabData = async () => {
            try {
                const response = await axios.get(baseUrl + 'view-lab/' + appt_id);
                setWoData(response.data);
                if (response.data.length > 0) {
                    const labDataId = response.data[0].id; // Assuming `id` is in the first response object
                    if (labDataId) {
                        const orderResponse = await axios.get(baseUrl + 'view-order-accept/' + labDataId);
                        if (Array.isArray(orderResponse.data) && orderResponse.data.some(item => item.id)) {
                            setIsAcceptDisabled(true);
                            setOrderResponse("Accepted");
                        } else {
                            setOrderResponse("Pending");
                        }
                    }
                    if (response.data[0].ltest_id) {
                        const ltestIds = response.data[0].ltest_id.split(',');
                        const deptNames = await Promise.all(
                            ltestIds.map(async (id) => {
                                const res = await axios.get(`${baseUrl}edit-subcat/${id}`);
                                return res.data.cat.category;
                            })
                        );
                        setlabDept(deptNames);
                    } else {
                        console.error("No ltest_id found in the response");
                    }
                }
            } catch (error) {
                console.error('Error fetching lab data:', error);
            }
        };
        fetchLabData();
    }, [appt_id]);
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            for (let i = 0; i < WoData.length; i++) {
                const row = WoData[i];
                const labTests = row.ltest_id.split(',');
                for (let j = 0; j < labTests.length; j++) {
                    const test = labTests[j].trim();
                    const department = labdept[j] || "N/A";
                    let workOrderEndpoint;
                    if (department === "BIOCHEMISTRY") {
                        workOrderEndpoint = `${baseUrl}get_bio_work/`;
                    } else if (department === "HAEMATOLOGY") {
                        workOrderEndpoint = `${baseUrl}get_hem_work/`;
                    } else if (department === "HORMONES") {
                        workOrderEndpoint = `${baseUrl}get_imm_work/`;
                    } else {
                        console.warn(`Unknown department: ${department}`);
                        continue;
                    }
                    const workOrderResponse = await axios.post(workOrderEndpoint);
                    const workorder = workOrderResponse.data.value;
                    const formData = new FormData();
                    formData.append('workorder', workorder);
                    formData.append('isaccept', '1');
                    formData.append('ltest', test);
                    formData.append('lab', row.id);
                    formData.append('labstatus', '1');
                    formData.append('acceptby', userName);
                    formData.append('ip_add', ipAddress);
                    formData.append('location', userLocation);
                    await axios.post(`${baseUrl}order-accept/`, formData, {
                        headers: {'content-type': 'multipart/form-data'},
                    });
                }
            }
            Swal.fire({
                title: 'All Orders Accepted Successfully',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false,
            });
            setTimeout(() => {
                window.location.href = '/lab-menu/';
            }, 2000);
        } catch (error) {
            console.error('Error during form submission:', error);
            Swal.fire('Error!', 'Failed to process all lab entries. Please try again later.', 'error');
        }
    };
    return (
        <section>
            <div>
                {WoData.map((row, index) => (
                    <div key={index} className="table-responsive">
                        <table className="erp-table-modern">
                            <tbody>
                            <tr>
                                <th className="mx-0 ps-5" rowSpan="2">
                                    <font>Name: {row.pat.patient}</font><br/>
                                    <font>PID: {row.pat.pat_id}</font><br/>
                                    <font>Consultant: {row.cons.consultant}</font><br/>
                                </th>
                            </tr>
                            <tr>
                                <th className="mx-5 ps-5">
                                    <font>Invoice No #: {row.lab_invoice}</font><br/>
                                    <font>Date: {row.lab_date}</font><br/>
                                </th>
                            </tr>
                            </tbody>
                        </table>
                        <div>
                            <table className="erp-table-modern">
                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th align="left">S.No</th>
                                    <th align="left">Department</th>
                                    <th align="left">Particulars</th>
                                    <th align="left">Order Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                {row.lab_test.split(',').map((test, subIndex) => (
                                    <tr key={`${index}-${subIndex}`}>
                                        <td style={{
                                            border: "1px solid",
                                            borderColor: "#2194d9"
                                        }}>{index + subIndex + 1}</td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            {labdept[subIndex] || "N/A"}
                                        </td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>{test.trim()}</td>
                                        <td style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            {orderResponse || "Pending"}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                        style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handleFormSubmit}
                        disabled={isAcceptDisabled}
                    >
                        Accept
                    </button>
                </div>
            </div>
        </section>
    );
}
export default CreateWO;
